import React from 'react';

import once from 'lodash/once';

import ItemsProviderWithStore from '@common/react/components/Core/ItemsProviderWithStore/ItemsProviderWithStore';
import { useApplicationContext } from '@common/react/components/Core/Application/Application';

import { AppointmentDotSetting, HiddenAppointmentDots } from '@app/objects/HiddenAppointmentDots';
import { User } from '@app/objects/User';

export interface HiddenAppointmentDotsProviderContext {
	isDotVisible: (setting: AppointmentDotSetting) => boolean;
}

export const createHiddenAppointmentDotsProviderContext = once(() => React.createContext({} as HiddenAppointmentDotsProviderContext));

export const useHiddenAppointmentDotsProviderContext: () => HiddenAppointmentDotsProviderContext = () =>
	React.useContext(createHiddenAppointmentDotsProviderContext());

const HiddenAppointmentDotsSetter: React.FC = ({ children }) => {
	const HiddenAppointmentDotsProviderContext = createHiddenAppointmentDotsProviderContext();

	const { getUser } = useApplicationContext();
	const user = getUser<User>();

	return <ItemsProviderWithStore<HiddenAppointmentDots>
		storeName="hiddenAppointmentDots"
		loadRequest="hiddenAppointmentDotsList"
		unhandledFilters={{ userId: user ? user.id : undefined }}
		pagination={{ pageSize: 10, total: 10 }}
		skipInitLoad
	>
		{({ state: { items } }) => {
			const isDotVisible = (setting: AppointmentDotSetting) => items
				.map((item) => item.appointmentDotSetting)
				.indexOf(setting) === -1;

			return (
				<HiddenAppointmentDotsProviderContext.Provider value={{ isDotVisible }}>
					{children}
				</HiddenAppointmentDotsProviderContext.Provider>
			);
		}}
	</ItemsProviderWithStore>;
};

export default HiddenAppointmentDotsSetter;
